<template>
  <v-dialog v-model="show" width="1000px">
    <ModalContentLabaRugi :onclose="close" />
  </v-dialog>
</template>

<script>
import ModalContentLabaRugi from './ModalContentLabaRugi.vue';

export default {
  components: {
    ModalContentLabaRugi,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>
